var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M9 4C5.364 4 2.258 6.284 1 9.503 2.258 12.723 5.364 15 9 15s6.742-2.277 8-5.497c-1.258-3.22-4.364-5.503-8-5.5Zm0 9.17c-2.007 0-3.636-1.643-3.636-3.667S6.993 5.836 9 5.836c2 0 3.636 1.643 3.636 3.667S11 13.17 9 13.17Zm0-5.867a2.188 2.188 0 0 0-2.182 2.2c0 1.217.975 2.2 2.182 2.2a2.188 2.188 0 0 0 2.182-2.2c0-1.217-.975-2.2-2.182-2.2Z"
})));
export default SvgIconEye;